<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />
      <div>
        <vs-button class="mr-4 sm:mb-0 mb-2">Upload photo</vs-button>
        <vs-button type="border" color="danger">Remove</vs-button>
        <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p>
      </div>
    </div>

    <!-- Info -->
    <vs-input
      class="w-full mb-base"
      label-placeholder="Username"
      v-model="username"
    ></vs-input>
    <vs-input
      class="w-full mb-base"
      label-placeholder="Name"
      v-model="name"
    ></vs-input>
    <vs-input
      class="w-full"
      label-placeholder="Email"
      v-model="email"
    ></vs-input>

    <vs-alert
      icon-pack="feather"
      icon="icon-info"
      class="h-full my-4"
      color="warning"
    >
      <span
        >Your account is not verified.
        <a href="#" class="hover:underline">Resend Confirmation</a></span
      >
    </vs-alert>

    <vs-input
      class="w-full my-base"
      label-placeholder="Company"
      v-model="company"
    ></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning"
        >Reset</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      username: "johny_01",
      name: this.$store.state.AppActiveUser.displayName,
      email: "john@admin.com",
      company: "SnowMash Technologies Pvt Ltd"
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    }
  }
};
</script>
